const messages = {
  "ui.modal.footer.cancelText": "Cancel",
  "ui.modal.footer.okText": "Okay",
} as const;

export default messages;
